import { CustomOption } from './CustomOption';
import { State } from './State';

export interface Order {
  id: number;
  typeId: number | null;
  requestedBy: string | null;
  companyName: string | null;
  phone: string | null;
  branchId: string | null;
  pobox: string | null;
  email: string | null;
  emailInvoicesTo: string | null;
  projectName: string | null;
  country: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  stateId: number | null;
  zipCode: string | null;
  onsitePoc: string | null;
  pocphone: string | null;
  projectDuration: string | null;
  deliveryDate: string | null;
  notes: string | null;
  dateCreated: string | null;

  orderEquipments: OrderEquipment[] | null;
  orderProducts: OrderProduct[] | null;
  orderSchedules: OrderSchedule[] | null;
  orderServices: OrderService[] | null;
  state: State | null;
}

export interface OrderEquipment {
  id: number;
  orderId: number | null;
  optionId: number | null;
  option: CustomOption | null;
}
export interface OrderProduct {
  id: number;
  orderId: number | null;
  optionId: number | null;
  option: CustomOption | null;
}
export interface OrderSchedule {
  id: number;
  orderId: number | null;
  optionId: number | null;
  option: CustomOption | null;
}
export interface OrderService {
  id: number;
  orderId: number | null;
  optionId: number | null;
  option: CustomOption | null;
}

export enum OrderTypeEnum {
  Order = 1,
  Quote = 2,
}
